import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

const Pets = (props) => {
   const theme = useTheme();
   return (
      <SvgIcon {...props} viewBox="0 0 40 40">
         <g
            id="ITO-Design-System"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
         >
            <g
               id="pets"
               transform="translate(-0.2369, 0)"
               fill={theme.palette.primary.main}
               fillRule="nonzero"
            >
               <path d="M10.7692 15.3846C10.7692 17.9336 8.70285 20 6.15384 20C3.60484 20 1.53846 17.9336 1.53846 15.3846C1.53846 12.8356 3.60484 10.7692 6.15384 10.7692C8.70285 10.7692 10.7692 12.8356 10.7692 15.3846Z" />
               <path d="M18.4615 9.23078C18.4615 11.7798 16.3952 13.8462 13.8462 13.8462C11.2971 13.8462 9.23077 11.7798 9.23077 9.23078C9.23077 6.68177 11.2971 4.61539 13.8462 4.61539C16.3952 4.61539 18.4615 6.68177 18.4615 9.23078Z" />
               <path d="M29.2308 9.23078C29.2308 11.7798 27.1644 13.8462 24.6154 13.8462C22.0664 13.8462 20 11.7798 20 9.23078C20 6.68177 22.0664 4.61539 24.6154 4.61539C27.1644 4.61539 29.2308 6.68177 29.2308 9.23078Z" />
               <path d="M36.9231 15.3846C36.9231 17.9336 34.8567 20 32.3077 20C29.7587 20 27.6923 17.9336 27.6923 15.3846C27.6923 12.8356 29.7587 10.7692 32.3077 10.7692C34.8567 10.7692 36.9231 12.8356 36.9231 15.3846Z" />
               <path d="M27.9767 23.9197C26.5541 22.2829 25.3605 20.8868 23.9216 19.2499C23.1695 18.3834 22.2048 17.5168 21.0602 17.1317C20.8803 17.0675 20.7005 17.0194 20.5206 16.9873C20.1118 16.9231 19.6704 16.9231 19.2452 16.9231C18.8201 16.9231 18.3786 16.9231 17.9535 17.0033C17.7736 17.0354 17.5938 17.0835 17.4139 17.1477C16.2694 17.5329 15.321 18.3994 14.5525 19.266C13.13 20.9028 11.9364 22.2989 10.4975 23.9358C8.35549 26.038 5.72298 28.3648 6.21351 31.6224C6.68769 33.2593 7.88131 34.88 10.0233 35.3454C11.2169 35.5861 15.0267 34.6393 19.0817 34.6393H19.376C23.4311 34.6393 27.2409 35.5701 28.4345 35.3454C30.5765 34.88 31.7701 33.2432 32.2443 31.6224C32.7511 28.3488 30.1186 26.0219 27.9767 23.9197Z" />
            </g>
         </g>
      </SvgIcon>
   );
};
export default Pets;
